/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';

/**
 * Since a single logical zone violation event can end up triggering many individual zone violation events to the backend we group events that happened close in time to each other between the same vehicle and badge into a single higher level zone violation incident.
 * 
 * Badge zone violation events are aggregated into zone violation incidents in a background worker.
 * @export
 * @interface BadgeZoneViolationIncident
 */
export interface BadgeZoneViolationIncident {
    /**
     * Unique ID for this incident.
     * @type {string}
     * @memberof BadgeZoneViolationIncident
     */
    id: string;
    /**
     * Time at which the zone violation incident started.
     * @type {Date}
     * @memberof BadgeZoneViolationIncident
     */
    startTime: Date;
    /**
     * Time at which the zone violation incident ended.
     * @type {Date}
     * @memberof BadgeZoneViolationIncident
     */
    stopTime: Date;
    /**
     * Vehicle that triggered this incident.
     * @type {string}
     * @memberof BadgeZoneViolationIncident
     */
    vehicleId: string;
    /**
     * User that was logged in to the vehicle at the time the incident occurred, if any.
     * @type {string}
     * @memberof BadgeZoneViolationIncident
     */
    userId?: string | null;
    /**
     * Minimum distance between the two devices in centimeters.
     * 
     * When external zones are used we don't know the distance to the other device.
     * @type {number}
     * @memberof BadgeZoneViolationIncident
     */
    minimumDistanceCm?: number | null;
    /**
     * Closest ELOshield zone which was violated during the incident.
     * @type {ProximityZone}
     * @memberof BadgeZoneViolationIncident
     */
    triggeredZone: ProximityZone;
    /**
     * ELOshield pedestrian badge that triggered the event.
     * @type {string}
     * @memberof BadgeZoneViolationIncident
     */
    pedestrianDeviceId: string;
    /**
     * Whether the badge enabled driver muting during the incident.
     * @type {boolean}
     * @memberof BadgeZoneViolationIncident
     */
    driverMutingEnabled: boolean;
}



/**
 * Check if a given object implements the BadgeZoneViolationIncident interface.
 */
export function instanceOfBadgeZoneViolationIncident(value: object): value is BadgeZoneViolationIncident {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('stopTime' in value) || value['stopTime'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    if (!('pedestrianDeviceId' in value) || value['pedestrianDeviceId'] === undefined) return false;
    if (!('driverMutingEnabled' in value) || value['driverMutingEnabled'] === undefined) return false;
    return true;
}

export function BadgeZoneViolationIncidentFromJSON(json: any): BadgeZoneViolationIncident {
    return BadgeZoneViolationIncidentFromJSONTyped(json, false);
}

export function BadgeZoneViolationIncidentFromJSONTyped(json: any, ignoreDiscriminator: boolean): BadgeZoneViolationIncident {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startTime': (new Date(json['startTime'])),
        'stopTime': (new Date(json['stopTime'])),
        'vehicleId': json['vehicleId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'minimumDistanceCm': json['minimumDistanceCm'] == null ? undefined : json['minimumDistanceCm'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
        'pedestrianDeviceId': json['pedestrianDeviceId'],
        'driverMutingEnabled': json['driverMutingEnabled'],
    };
}

export function BadgeZoneViolationIncidentToJSON(json: any): BadgeZoneViolationIncident {
    return BadgeZoneViolationIncidentToJSONTyped(json, false);
}

export function BadgeZoneViolationIncidentToJSONTyped(value?: BadgeZoneViolationIncident | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'startTime': value['startTime'].toISOString(),
        'stopTime': value['stopTime'].toISOString(),
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'minimumDistanceCm': value['minimumDistanceCm'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
        'pedestrianDeviceId': value['pedestrianDeviceId'],
        'driverMutingEnabled': value['driverMutingEnabled'],
    };
}

